import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { PropType } from "vue";

import { ContentStructureSection } from "@/models/content-structure.model";
import { PendingTransition } from "@/models/transition-state.model";

import Popup from "@/components/Popup.vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TransitionConfirmation',
  props: {
  section: {
    required: true,
    type: Object as PropType<ContentStructureSection>
  },
  pendingTransition: {
    required: true,
    type: Object as PropType<PendingTransition>
  },
  modelValue: {
    required: true,
    type: String
  },
  isTransitionSubmitting: {
    type: Boolean,
    required: true
  }
},
  emits: [
  "confirmTransition",
  "closeTransitionConfirmation",
  "update:modelValue"
],
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    onClosePopup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeTransitionConfirmation')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h3", null, [
        _cache[4] || (_cache[4] = _createTextVNode(" Move ", -1)),
        _createElementVNode("em", null, _toDisplayString(__props.section.name), 1),
        _cache[5] || (_cache[5] = _createTextVNode(" to ", -1)),
        _createElementVNode("em", null, _toDisplayString(__props.pendingTransition.name), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("form", {
        id: "transition-confirmation",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('confirmTransition')), ["prevent"]))
      }, [
        _createVNode(RightSidebarTitle, { title: 'Enter a message:' }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createElementVNode("small", { class: "pl-2" }, "(optional)", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("textarea", {
          value: props.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, null, 40, _hoisted_1)
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeTransitionConfirmation'))),
        type: "button",
        disabled: __props.isTransitionSubmitting
      }, " Cancel ", 8, _hoisted_2),
      _createElementVNode("button", {
        class: "btn-1",
        "data-testing": "confirm-transition",
        type: "submit",
        form: "transition-confirmation",
        disabled: __props.isTransitionSubmitting
      }, " Confirm ", 8, _hoisted_3)
    ]),
    _: 1
  }))
}
}

})